import { render, staticRenderFns } from "./StatisticsContainer.vue?vue&type=template&id=2b6d222e&"
import script from "./StatisticsContainer.vue?vue&type=script&lang=ts&"
export * from "./StatisticsContainer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports